<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 4H19C19.5304 4 20.0391 4.21071 20.4142 4.58579C20.7893 4.96086 21 5.46957 21 6V10H3V6C3 5.46957 3.21071 4.96086 3.58579 4.58579C3.96086 4.21071 4.46957 4 5 4Z"
      fill="#3CB149"
    />
    <path
      d="M3 10H21V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V10Z"
      fill="#D5D8DC"
    />
    <path d="M8 2H6V6H8V2Z" fill="#363C43" />
    <path d="M9 12H7V14H9V12Z" fill="#363C43" />
    <path d="M13 12H11V14H13V12Z" fill="#363C43" />
    <path d="M17 12H15V14H17V12Z" fill="#363C43" />
    <path d="M18 2H16V6H18V2Z" fill="#363C43" />
  </svg>
</template>
<script>
export default {
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
  },
};
</script>
